<template>
    <div class="footer" v-once>
        <div v-for="(section) in footerLinks" :key="section.name">
            <div class="webBody sectionName">{{ section.name }}</div>
            <div v-for="(link) in section.links" :key="link.name">
                <a class="link" :href="link.path" target="_blank">{{link.name}}</a>
            </div>
        </div>
        <div class="bottom">
            <div>
                <IconBase width="122" height="32" iconColor="#fff"
                          icon-name="companyLogoIcon" class="logo"></IconBase>
            </div>
            <div class="mark">
                {{ (new Date()).getUTCFullYear() }} ironSource
            </div>
        </div>
    </div>
</template>

<script>
import IconBase from 'components/IconBase.vue';
import { links } from './consts';

export default {
    name: 'signUpFooter',
    components: { IconBase },
    data() {
        return {
            footerLinks: links
        };
    }
};
</script>

<style scoped lang="scss">
    @import "~styles/styleGuide.V2";
    @import "~styles/screens.scss";

    .footer {
        margin-top: 20px;
        background-color: $dark-500;
        padding: 95px 95px 82px 85px;
        display: grid;
        grid-template-columns: 1fr 1fr 1fr 1fr;
        color: $white;

        @media #{$mobile} {
            grid-template-columns: 1fr;
            grid-row-gap: 20px;
        }
    }

    .link {
        font-family: "GroteskDs75", sans-serif;
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        letter-spacing: normal;
        line-height: 2.14;
        text-decoration: none;

        &:active, &:visited, &:link, &:hover {
            color: $white;
            text-decoration: none;
        }
    }

    .sectionName {
        margin-bottom: 16px;
    }

    .mark {
        font-family: "HelveticaNeue", sans-serif;
        font-size: 16px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        letter-spacing: normal;
        color: $white;
        text-align: right;
    }

    .bottom {
        grid-column: 1 / div 4;
        display: grid;
        grid-template-columns: 1fr 1fr;
        margin-top: 60px;

        @media #{$mobile} {
            grid-column: auto;
        }
    }
</style>
